<div [class.isPrinting]="printService.isPrinting">
  <div class="row margin-bottom-10px " id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-insemination" id="IL">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px data-color-white background-insemination">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
                </i>-->
                Insemination
              </label>
            </div>
            <div class="col-md-6 float-right text-align-end padding-right-0px display-edit">
              <div class="row float-right margin-left-0px margin-right-0px">
                <div class="offset-md-3 col-md-1  padding-left-0px">
                  <!--<a class="nav-link-hand education-navlink data-color-new" title="To View images">
        <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
      </a>-->
                  
                    <button type="button" (click)="Top()"
                            class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                            name="upload" title="Goto Top">
                      <i class="fas fa-long-arrow-alt-up font-size-11"></i>
                    </button>
                  
                  
                </div>
                <div class="col-md-1 padding-left-11px">
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload" title="Goto Bottom">
                    <i class="fas fa-long-arrow-alt-down font-size-11 "></i>
                  </button>
                </div>
                <div class="col-md-1 padding-left-11px">
                  <a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Well Culture'" title="print" (click)="printinsemi()">
                    <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
                  </a>
                  <a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Droplet Culture'" title="print" (click)="printinsemidroplet()">
                    <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
                  </a>
                </div>
              </div>
              <!--<a class="nav-link-hand education-navlink margin-right-10px " title="edit">
    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
  </a>-->
             
            </div>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="row  margin-top-10" *ngIf="GradingModel=='Well Culture'">
            <div class="col-md-12 padding-left-24px">
              <div class="card border-all-1px">
                <div class="card-header background-primary font-size-15px padding-top-6px padding-bottom-6px color-Assign padding-left-10px padding-right-10px border-bottom-1px">
                  Oocytes For Insemination
                </div>
                <div class="card-body padding-all-0px">
                  <div class="row">
                    <div class="col-md-12 ">
                      <div class="table-component margin-bottom-0px">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero">

                            <thead class="">
                              <tr>


                                <th class="padding-top-4px padding-bottom-4px width-47px font-weight-normal">Sno</th>
                                <th class="padding-top-4px padding-bottom-4px font-weight-normal">Well#</th>
                                <th class="padding-top-4px padding-bottom-4px font-weight-normal">Occ/Denuded</th>
                                <th class="padding-top-4px padding-bottom-4px font-weight-normal">Morphology</th>
                                <th class="white-space-preline padding-top-4px padding-bottom-4px padding-left-0px font-weight-normal">Technique</th>

                              </tr>
                            </thead>
                            <tbody class="table-body">
                              <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                              <!--</ng-container>-->
                              <tr *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">


                                <td class="text-align-center padding-top-0px padding-bottom-0px padding-left-0px">{{i+1}}</td>
                                <td class="text-align-left padding-top-0px padding-bottom-0px padding-right-0px">{{l.WellNo}}</td>
                                <td class="padding-top-0px padding-bottom-0px">{{l.OocyteQualityPre}}/{{l.OocyteQualityPost}}</td>
                                <td class="padding-top-0px padding-bottom-0px">{{l.Morphology}}</td>
                                <td class="padding-all-0px">
                                  <!--<CodeTypeValue CodeType="InsTe" [(ngModel)]="l.technique" SelectedValue="l.technique"
                          required></CodeTypeValue>-->
                                  {{l.technique}}
                                </td>





                              </tr>
                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row  margin-top-10" *ngIf="GradingModel=='Well Culture'">
            <div class="col-md-12 padding-left-24px">
              <div class="card border-all-1px">
                <div class="card-header background-primary font-size-15px padding-top-6px padding-bottom-6px color-Assign padding-left-10px padding-right-10px border-bottom-1px">
                  Insemination Log
                </div>
                <div class="card-body padding-all-0px">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="card margin-bottom-0px">

                        <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                          <div class="table-component margin-bottom-0px">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero">

                                <thead class="">
                                  <tr>
                                    <th class="min-width-0px font-weight-normal padding-top-4px padding-bottom-4px">Date &amp; Time</th>

                                    <th class="min-width-0px font-weight-normal padding-top-4px padding-bottom-4px">No of times per hour</th>
                                    <th class="padding-left-5px font-weight-normal padding-top-4px padding-bottom-4px">Processed By</th>

                                    <th class="font-weight-normal padding-top-4px padding-bottom-4px">Doctor</th>

                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentIvfCycleInseminationLogByCycleWithDOCController">
                                    <td class="padding-top-0px padding-bottom-0px">


                                      {{l.InseminationDate| date:'dd-MMM-yyyy'}} &amp; {{l.InseminationTime| date: 'mediumTime'}}

                                    </td>
                                    <td class="padding-top-0px padding-bottom-0px padding-left-4 text-align-center">

                                      {{l.NtimesInformed}}


                                    </td>

                                    <td class="padding-top-0px padding-bottom-0px padding-left-4 ">

                                      {{l.ProcessedByName}}
                                    </td>
                                    <td class="padding-top-0px padding-bottom-0px  white-spce-pre">
                                      <div class="">{{l.DoctorName}}</div>
                                      <div>{{l.NurseName}}</div>
                                    </td>




                                  </tr>


                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row  margin-top-10" *ngIf="GradingModel=='Droplet Culture'">
            <div class="col-md-12 padding-left-24px">
              <div class="card border-all-1px">
                <div class="card-header background-primary font-size-15px padding-top-6px padding-bottom-6px color-Assign padding-left-10px padding-right-10px border-bottom-1px">
                  Insemination
                </div>
                <div class="card-body padding-all-0px">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="card margin-bottom-0px">

                        <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                          <div class="table-component margin-bottom-0px padding-all-5px">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero overflow-y-hidden">
                                <thead class="">
                                  <tr>
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px">Technique</th>
                                    <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px">Injected/Inseminated</th>

                                    <th class="padding-top-4px padding-bottom-4px font-size-12px">Details</th>
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px">Done By</th>
                                   
                                  </tr>
                                </thead>

                                <tbody class="table-body">
                                  <tr *ngFor="let l of CurrentIvfCycleInseminationByCycleController">
                                    <td class="padding-top-0px padding-bottom-0px ">


                                      <!--<CodeTypeValue CodeType="InsTe"
                                     id="l.Technique"
                                     [(ngModel)]="l.Technique" SelectedValue="l.Technique"
                                     name="l.Technique" required>
                      </CodeTypeValue>-->
                                      <label class="margin-bottom-0px">{{l.Technique}}</label>
                                    </td>
                                    <td class="padding-top-0px padding-bottom-0px text-align-center">
                                      <!--<input type="text" class="form-control text-align-right" placeholder=""
                             [(ngModel)]="l.OocyteCount"
                             maxlength="2" required>-->
                                      <label class="margin-bottom-0px">{{l.OocyteCount}}</label>
                                    </td>


                                    <td class="padding-top-0px padding-bottom-0px">
                                      <!--<input type="text" class="form-control" placeholder=""
                             [(ngModel)]="l.Remarks"
                             maxlength="2" required>-->
                                      <label class="margin-bottom-0px">{{l.Remarks}}</label>
                                    </td>
                                    <td class="padding-top-0px padding-bottom-0px">
                                      <!--<input type="text" class="form-control" placeholder=""
                             [(ngModel)]="l.PrescribedByName"
                             maxlength="2" required>-->
                                      <label class="margin-bottom-0px">{{l.PrescribedByName}}</label>
                                    </td>
                                  
                                  </tr>

                                </tbody>
                              </table>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row  margin-top-10" *ngIf="GradingModel=='Droplet Culture'">
            <div class="col-md-12 padding-left-24px">
              <div class="card border-all-1px">
                <div class="card-header background-primary font-size-15px padding-top-6px padding-bottom-6px color-Assign padding-left-10px padding-right-10px border-bottom-1px">
                  Insemination Log
                </div>
                <div class="card-body padding-all-0px">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="card margin-bottom-0px background-lightpink">

                        <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                          <div class="table-component margin-bottom-0px padding-all-5px">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero overflow-y-hidden">

                                <thead class="">
                                  <tr>
                                    <th class="min-width-0px">Date &amp; Time</th>

                                    <!--<th class="min-width-0px">No of times per hour</th>-->
                                    <th class="padding-left-5px">Done By</th>

                                    <th>Doctor</th>
                                    
                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentIvfCycleInseminationLogByCycleWithDOCController">
                                    <td class="td-padding">


                                      {{l.InseminationDate| date:'dd-MMM-yyyy'}} &amp; {{l.InseminationTime| date: 'mediumTime'}}

                                    </td>
                                    <!--<td class="td-padding text-align-center">

                      {{l.NtimesInformed}}


                    </td>-->

                                    <td class="td-padding ">

                                      {{l.ProcessedByName}}
                                    </td>
                                    <td class="td-padding text-align-center white-spce-pre">
                                      <div class="broder-right-1px-dark">{{l.DoctorName}}</div>
                                      <div>{{l.NurseName}}</div>
                                    </td>



                              

                                  </tr>


                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
